import { queryKeys } from '@trukt/query-keys';
import { ReportCategoryLiterals } from '@trukt/tms-api/ReportServices';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useApiContext } from './ApiProvider';

const MAX_ROW_COUNT = 25;
// 2 minutes
const JOB_STATUS_REFETCH_INTERVAL = 1000 * 60 * 2;

export function useReportsInfiniteQuery(reportCategory: ReportCategoryLiterals) {
  const { truktApi } = useApiContext();
  const request = {
    queryParams: { category: reportCategory, rc: MAX_ROW_COUNT },
  };

  return useInfiniteQuery({
    queryKey: queryKeys.report.search(request),
    initialPageParam: 0,
    queryFn: async ({ pageParam = 0 }) => {
      const response = await truktApi.report.search({
        ...request,
        queryParams: { ...request.queryParams, pg: pageParam },
      });
      return response.data;
    },
    getNextPageParam: (lastPage, pages) => {
      return lastPage.next ? pages.length : undefined;
    },
    staleTime: JOB_STATUS_REFETCH_INTERVAL,
  });
}
